import { Field } from "formik";
import get from "lodash/get";
import { useState } from "react";
import deleteIcon from "../../assets/icons/delete-bin.svg";
import { IMAGE_URL } from "../../config";

export const FormMultiImageVideoField = ({
  name = "media",
  label = "Media Upload",
  uploadIcon,
  addCoverIcon,
  uploadPlaceholder,
  className = "",
  ...props
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [uploadStatuses, setUploadStatuses] = useState([]);
  const [onErrorOpen, setOnErrorOpen] = useState(false);
  const [onErrorMessage, setOnErrorMessage] = useState(
    "Some files exceed 100MB and were not uploaded"
  );

  const handleFileChange = async (event, setFieldValue, values) => {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) return;

    const MAX_SIZE = 100 * 1024 * 1024;

    const oversizedFiles = files.filter((file) => file.size > MAX_SIZE);
    const validFiles = files.filter((file) => file.size <= MAX_SIZE);

    if (oversizedFiles.length > 0) {
      const fileNames = oversizedFiles.map((f) => f.name).join(", ");
      //   setOnErrorMessage(
      //     `The following files exceed 100MB and were not uploaded:\n${fileNames}`
      //   );
      //   setOnErrorOpen(true);
      //   setTimeout(timeOutFnc, 3000);
    }

    if (validFiles.length === 0) return;

    const newStatuses = validFiles.map((file, idx) => ({
      id: `${Date.now()}-${idx}`,
      file,
      status: "loading",
      progress: 0,
      url: null,
    }));

    setUploadStatuses((prev) => [...prev, ...newStatuses]);

    const uploadPromises = newStatuses.map(
      (status) =>
        new Promise((resolve) => {
          const formData = new FormData();
          formData.append("file", status.file);

          const xhr = new XMLHttpRequest();

          xhr.upload.addEventListener("progress", (e) => {
            if (e.lengthComputable) {
              const percentComplete = Math.round((e.loaded / e.total) * 100);
              setUploadStatuses((prev) =>
                prev.map((s) =>
                  s.id === status.id ? { ...s, progress: percentComplete } : s
                )
              );
            }
          });

          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              if (xhr.status >= 200 && xhr.status < 300) {
                const response = JSON.parse(xhr.responseText);
                const url = response.data.filePath;
                const type = status.file.type.startsWith("image/")
                  ? "image"
                  : "video";

                setUploadStatuses((prev) =>
                  prev.map((s) =>
                    s.id === status.id
                      ? {
                          ...s,
                          progress: 100,
                          status: "done",
                          url: url,
                          type: type,
                        }
                      : s
                  )
                );

                resolve({ url, type });
              } else {
                setUploadStatuses((prev) =>
                  prev.map((s) =>
                    s.id === status.id ? { ...s, status: "error" } : s
                  )
                );
                resolve(null);
              }
            }
          };

          xhr.open(
            "POST",
            IMAGE_URL
          );
          xhr.send(formData);
        })
    );

    const uploadedResults = await Promise.all(uploadPromises);
    const successfulUploads = uploadedResults.filter(Boolean);

    var statuses = [...uploadStatuses];
    for (let index = 0; index < successfulUploads.length; index++) {
      const element = successfulUploads[index];
      statuses = statuses.filter((s) => s.url == element.url);
    }
    setUploadStatuses([...statuses]);

    const currentMedia = values.media || [];
    const updatedMedia = [...currentMedia, ...successfulUploads].map(
      (item, index) => ({
        ...item,
        index,
      })
    );

    setFieldValue(name, updatedMedia);
  };

  const handleDelete = (index, setFieldValue, values) => {
    const newMedia = [...values[name]];
    newMedia.splice(index, 1);
    setFieldValue(name, newMedia);
  };

  const handleDragStart = (index) => setDraggedIndex(index);
  const handleDragOver = (e) => e.preventDefault();

  const handleDrop = (index, values, setFieldValue) => {
    if (draggedIndex === null || draggedIndex === index) return;
    const updatedItems = [...values[name]];
    const draggedItem = updatedItems.splice(draggedIndex, 1)[0];
    updatedItems.splice(index, 0, draggedItem);
    setFieldValue(name, updatedItems);
    setDraggedIndex(null);
  };

  const handleTouchStart = (index) => setDragIndex(index);

  const handleTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    const elements = document.querySelectorAll("[data-draggable-index]");

    let closestIndex = null;
    let closestDistance = Infinity;

    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const index = Number(el.getAttribute("data-draggable-index"));
      const centerY = rect.top + rect.height / 2;
      const distance = Math.abs(touch.clientY - centerY);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    if (closestIndex !== null && closestIndex !== hoverIndex) {
      setHoverIndex(closestIndex);
    }
  };

  const handleTouchEnd = (values, setFieldValue) => {
    if (dragIndex !== null && hoverIndex !== null && dragIndex !== hoverIndex) {
      const newMedia = Array.from(values[name]);
      const [movedItem] = newMedia.splice(dragIndex, 1);
      newMedia.splice(hoverIndex, 0, movedItem);
      setFieldValue(name, newMedia);
    }
    setDragIndex(null);
    setHoverIndex(null);
  };

  return (
    <Field name={name}>
      {({ form, meta }) => {
        const values = form.values;
        const mediaItems = get(values, name) || [];

        return (
          <div className={`rounded-lg ${className}`}>
            <div className="flex justify-between items-center my-2">
              <p className="text-lg font-medium">{label}</p>
              {mediaItems.length > 0 && (
                <label className="cursor-pointer text-white bg-primary px-4 py-2 rounded-lg">
                  Add Media
                  <input
                    type="file"
                    multiple
                    accept="image/*,video/*"
                    className="hidden"
                    onChange={(e) =>
                      handleFileChange(e, form.setFieldValue, values)
                    }
                  />
                </label>
              )}
            </div>
            <div
              className={`my-2 border-[1px] border-lightBg rounded-xl p-2 overflow-x-hidden bg-white ${
                mediaItems?.length > 0
                  ? "h-fit"
                  : "h-[30rem] flex justify-center items-center"
              }`}
            >
              <div
                className={`grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 mt-4`}
              >
                {mediaItems.map((item, index) => (
                  <div
                    key={index}
                    data-draggable-index={index}
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragOver={handleDragOver}
                    onDrop={() => handleDrop(index, values, form.setFieldValue)}
                    onTouchStart={() => handleTouchStart(index)}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={() =>
                      handleTouchEnd(values, form.setFieldValue)
                    }
                    className={`relative w-full h-60 rounded-lg overflow-hidden border ${
                      hoverIndex === index
                        ? "border-blue-500"
                        : "border-lightBg"
                    }`}
                  >
                    {item.type === "image" ? (
                      <img
                        src={item.url}
                        alt={`media-${index}`}
                        className="w-full h-full object-cover"
                        width={800}
                        height={600}
                      />
                    ) : (
                      <video controls className="w-full h-full object-cover">
                        <source src={item.url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    )}
                    <div
                      className="absolute top-2 right-2 bg-errorColor p-1 rounded-full shadow cursor-pointer p-1"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(index, form.setFieldValue, values);
                      }}
                    >
                      <img src={deleteIcon} width={14} height={14} />
                    </div>
                  </div>
                ))}

                {uploadStatuses
                  .filter((status) => status.status == "done")
                  .map((status, index) => (
                    <div
                      key={index}
                      className="relative w-[20rem] 2xl:max-w-[15rem] lg:max-w-[14rem] max-w-[12rem] 2xl:h-[15rem] lg:h-[14rem] h-[12rem] rounded-lg m-2"
                    >
                      <div className="bg-white w-full h-full shadow cursor-move">
                        {status?.type === "image" ? (
                          <img
                            src={status.url}
                            alt={`Media uploaded`}
                            className="w-full h-full object-cover rounded-lg"
                            width={2000}
                            height={2000}
                          />
                        ) : (
                          <video
                            controls
                            className="w-full h-full object-cover rounded-lg"
                          >
                            <source src={status.url} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        )}
                      </div>
                      {status?.type === "video" && (
                        <label className="bg-lightBg text-fs_10 absolute top-0 left-1 px-1 rounded-md my-1 font-fw_500">
                          Video
                        </label>
                      )}
                    </div>
                  ))}

                {uploadStatuses
                  .filter((status) => status.status !== "done")
                  .map((status) => (
                    <div
                      key={status.id}
                      className="2xl:w-[15rem] lg:w-[14rem] w-[12rem] 2xl:h-[15rem] lg:h-[14rem] h-[12rem] rounded-lg relative p-2"
                    >
                      {status.status === "loading" ? (
                        <div className="w-full h-full rounded-lg bg-gray-200 flex flex-col items-center justify-center text-sm text-gray-700 relative p-2">
                          <div className="absolute inset-0 flex items-center justify-center">
                            <p>{status.progress}%</p>
                          </div>
                          <div
                            className="absolute bottom-1 left-0 h-1 bg-primary ronded-lg"
                            style={{ width: `${status.progress}%` }}
                          />
                        </div>
                      ) : (
                        <div className="w-full h-full rounded-lg bg-red-100 flex flex-col items-center justify-center text-red-600 text-sm">
                          <p>Failed</p>
                          <button
                            onClick={() =>
                              setUploadStatuses((prev) =>
                                prev.filter((s) => s.id !== status.id)
                              )
                            }
                            className="mt-2 text-xs text-blue-600 underline"
                          >
                            Remove
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
              </div>

              {mediaItems.length === 0 && (
                <div className="mt-4 text-center bg-[#EDF4F94D] p-6 rounded-lg">
                  <p className="mt-2 text-sm">
                    Drag & Drop or Browse to upload
                  </p>
                  <label className="inline-block mt-4 border border-secondary text-secondary px-4 py-2 rounded cursor-pointer">
                    Browse Files
                    <input
                      type="file"
                      multiple
                      accept="image/*,video/*"
                      className="hidden"
                      onChange={(e) =>
                        handleFileChange(e, form.setFieldValue, values)
                      }
                    />
                  </label>
                </div>
              )}
            </div>
          </div>
        );
      }}
    </Field>
  );
};
